import { Root } from "@radix-ui/react-tabs";
import { styled } from "@vitality-ds/system";
import BaseRootStyles from "./styles/BaseRoot.styles";
export default styled(Root, BaseRootStyles);